import React from 'react';
import { Link } from 'react-router-dom';

/** Route destinations are links; local views use keyboard-accessible tabs. */
export default function PageTabs({ items, active, onChange, label, variant = 'line', disabled = false, idPrefix, panelId }) {
  return <nav className={`admin-tabs admin-tabs-${variant}`} aria-label={label} role={onChange ? 'tablist' : undefined}>
    {items.map(({ id, label: text, to }) => {
      const selected = active === id;
      if (to) return <Link key={id} to={to} className={`admin-tab ${selected ? 'is-selected' : ''}`} aria-current={selected ? 'page' : undefined}>{text}</Link>;
      return <button key={id} type="button" disabled={disabled} id={idPrefix ? `${idPrefix}-${id}` : undefined} aria-controls={panelId} role="tab" aria-selected={selected} tabIndex={selected && !disabled ? 0 : -1} className={`admin-tab ${selected ? 'is-selected' : ''}`} onClick={() => onChange(id)} onKeyDown={event => {
        const index = items.findIndex(item => item.id === active);
        const next = event.key === 'Home' ? 0 : event.key === 'End' ? items.length - 1 : event.key === 'ArrowRight' ? (index + 1) % items.length : event.key === 'ArrowLeft' ? (index - 1 + items.length) % items.length : null;
        if (next == null) return;
        event.preventDefault();
        onChange(items[next].id);
        event.currentTarget.parentElement.querySelectorAll('button')[next]?.focus();
      }}>{text}</button>;
    })}
  </nav>;
}
